/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Too_LargeInputs */



/**
* | output |
* | --- |
* | "This file is too large to index." |
*
* @param {Embedding_Error_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_too_large = /** @type {((inputs?: Embedding_Error_Too_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Too_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Datei ist zu groß, um indexiert zu werden.")
	return /** @type {LocalizedString} */ ("This file is too large to index.")
});